/* ============================================================================
   ETHOS — Hero slider (yatay kayma geçişi)
   ============================================================================
   Neden Dawn'ın slideshow-component'i kullanılmıyor: o slider kaydırma (scroll)
   tabanlı — konumu `scrollLeft`ten okur, `scrollTo` ile kaydırır. Geçiş eğrisi
   `scroll-behavior: smooth`a bırakıldığı için hız eğrisi ayarlanamaz. Müşteri
   "yavaş başlayıp hızlanan" bir kayma istedi; o yüzden geçiş burada transform
   ile yapılıyor (süre/eğri: assets/ethos-hero-slider.css'teki iki değişken).

   Kullanılan işaretleme Dawn'ınkiyle AYNI (sections/slideshow.liquid):
     .slideshow[data-autoplay][data-speed]  → kap
     .slideshow__slide                      → slaytlar
     .slider-counter__link                  → noktalar (iki kontrol satırı var)
     .slider-counter--current               → sayaç (slider_visual: counter)
     button[name="previous"|"next"]         → oklar
     .slideshow__autoplay                   → duraklat/oynat
   Böylece section ayarları, çeviriler ve stiller olduğu gibi çalışıyor.

   Geçiş mantığı: slaytlar grid ile üst üste. Geçişte giren slayt yön kadar
   ötelenmiş konumdan (±genişlik) 0'a, çıkan slayt 0'dan ters yöne gider.
   Kayma CSS geçişiyle değil kare kare yapılır ve her konum cihaz pikseline
   yuvarlanır: eğrinin yavaş biten kuyruğunda piksel altı adımlar iPhone'da
   görüntüyü titretip sonda keskinleştiriyordu.
   ========================================================================= */
(function () {
  if (customElements.get('ethos-hero-slider')) return;

  class EthosHeroSlider extends HTMLElement {
    connectedCallback() {
      // Düzenleyicide bölüm taşınınca yeniden bağlanır: dinleyiciler ikinci kez eklenmesin
      if (this.kuruldu) {
        this.isaretle(this.indeks);
        this.basla();
        return;
      }
      this.kap = this.querySelector('.slideshow');
      this.slaytlar = Array.from(this.querySelectorAll('.slideshow__slide'));
      if (!this.kap || this.slaytlar.length === 0) return;

      this.noktalar = Array.from(this.querySelectorAll('.slider-counter__link'));
      this.sayaclar = Array.from(this.querySelectorAll('.slider-counter--current'));
      this.oynatDugmeleri = Array.from(this.querySelectorAll('.slideshow__autoplay'));
      this.azHareket = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.sure = (parseFloat(this.kap.dataset.speed) || 5) * 1000;
      this.otomatikIstendi = this.kap.dataset.autoplay === 'true';
      this.duraklatildi = false;
      this.indeks = 0;
      this.gecisSuruyor = false;
      this.odakIcerde = false;
      this.bekleyen = null;

      this.classList.add('ethos-slider--hazir');
      this.isaretle(0);

      this.querySelectorAll('button[name="previous"]').forEach((b) =>
        b.addEventListener('click', () => this.istekGoreli(-1))
      );
      this.querySelectorAll('button[name="next"]').forEach((b) =>
        b.addEventListener('click', () => this.istekGoreli(1))
      );
      this.noktalar.forEach((n, i) =>
        n.addEventListener('click', () => this.istekMutlak(i % this.slaytlar.length))
      );
      this.oynatDugmeleri.forEach((b) => b.addEventListener('click', () => this.otomatigiCevir()));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.istekGoreli(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.istekGoreli(1); }
      });

      let basX = null, basY = null;
      this.kap.addEventListener('touchstart', (e) => {
        this.isit(this.indeks - 1);
        this.isit(this.indeks + 1);
        basX = e.changedTouches[0].clientX; basY = e.changedTouches[0].clientY;
      }, { passive: true });
      this.kap.addEventListener('touchend', (e) => {
        if (basX === null) return;
        const dx = e.changedTouches[0].clientX - basX;
        const dy = e.changedTouches[0].clientY - basY;
        // Dikey kaydırmayı (sayfa scroll'u) yatay kaydırma sanmayalım
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          this.istekGoreli(dx < 0 ? 1 : -1);
        }
        basX = basY = null;
      }, { passive: true });

      document.addEventListener('visibilitychange', () => (document.hidden ? this.durdur() : this.basla()));
      // Odak slider'in icindeyken otomatik donus DURUR ve durmus kalir: bayrak
      // olmadan git() icindeki basla() cagrisi duraklatmayi hemen iptal ediyordu.
      // Yalnız klavye odağı duraklatsın: dokunma/tıklama da slaytı odaklıyor
      // ve otomatik dönüşü fark ettirmeden kalıcı olarak durduruyordu.
      this.addEventListener('focusin', (e) => {
        let klavye = true;
        try { klavye = e.target.matches(':focus-visible'); } catch (_) {}
        if (!klavye) return;
        this.odakIcerde = true;
        this.durdur();
      });
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) { this.odakIcerde = false; this.basla(); }
      });
      this.azHareket.addEventListener('change', () => (this.azHareket.matches ? this.durdur() : this.basla()));
      window.matchMedia('(min-width: 750px)').addEventListener('change', () => this.basla());

      this.kuruldu = true;
      this.basla();

      // Tembel görsel geçişte boş kaymasın: sıradakini sayfa yüklenince ısıt.
      if (document.readyState === 'complete') this.isit(1);
      else window.addEventListener('load', () => this.isit(1), { once: true });
    }

    isit(i) {
      const n = this.slaytlar.length;
      const s = this.slaytlar[((i % n) + n) % n];
      if (!s) return;
      s.querySelectorAll('img').forEach((img) => {
        if (img.loading === 'lazy') img.loading = 'eager';
        // Görsel kayma başlamadan çözülsün; iOS'ta ilk karelerde takılma olmasın
        if (img.decode) img.decode().catch(() => {});
      });
    }

    disconnectedCallback() {
      this.durdur();
      this.tur = (this.tur || 0) + 1;
      cancelAnimationFrame(this.kareId);
      clearTimeout(this.emniyet);
      clearTimeout(this.gizleZaman);
      this.gecisSuruyor = false;
      this.bekleyen = null;
    }

    /* Geçişsiz durum ayarı (ilk yükleme ve geçiş sonu). `kalan`: az önce çıkan
       slayt; bitiş karesinde gizlenmez, ekran dışında bir süre daha durur. */
    isaretle(i, kalan) {
      this.slaytlar.forEach((s, k) => {
        const aktif = k === i;
        s.classList.toggle('ethos-slider--aktif', aktif);
        if (s !== kalan) {
          s.classList.remove('ethos-slider--cikan');
          // Duran slayt hareketin bittiği değerde kalır: iOS Safari'de bitişte
          // transform'u kaldırmak katmanı yeniden kurdurup bir kare titretiyordu.
          s.style.transform = aktif ? 'translate3d(0, 0, 0)' : '';
        }
        s.setAttribute('aria-hidden', aktif ? 'false' : 'true');
        s.inert = !aktif;
      });
      this.noktalar.forEach((d, k) => {
        const aktif = k % this.slaytlar.length === i;
        d.classList.toggle('slider-counter__link--active', aktif);
        if (aktif) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      this.sayaclar.forEach((c) => (c.textContent = i + 1));
    }

    /* Kullanıcı isteği. Geçiş sürerken gelen istek YUTULMAZ, sıraya alınır:
       900 ms boyunca tıklama/kaydırma tepkisiz kalmasın. Sadece son istek
       tutulur — üst üste beş tıklamada beş geçiş oynatmanın anlamı yok. */
    istekMutlak(hedef) {
      if (this.gecisSuruyor) { this.bekleyen = { tur: 'mutlak', hedef: hedef }; return; }
      if (hedef === this.indeks) return;
      this.git(hedef, hedef > this.indeks ? 1 : -1);
    }

    istekGoreli(adim) {
      if (this.gecisSuruyor) { this.bekleyen = { tur: 'goreli', adim: adim }; return; }
      this.git(this.indeks + adim, adim);
    }

    kuyruguBosalt() {
      const b = this.bekleyen;
      this.bekleyen = null;
      if (!b) return;
      if (b.tur === 'mutlak') this.istekMutlak(b.hedef);
      else this.istekGoreli(b.adim);
    }

    git(hedef, yon) {
      const n = this.slaytlar.length;
      if (n < 2 || this.gecisSuruyor) return;
      const yeni = ((hedef % n) + n) % n;
      if (yeni === this.indeks) return;

      const cikan = this.slaytlar[this.indeks];
      const giren = this.slaytlar[yeni];
      const d = yon || 1;

      // Klavyeyle gezinen kullanıcının odağı çıkan slaytın içindeyse, o slayt
      // inert olunca odak body'ye düşüyor ve ok tuşları çalışmaz hale geliyordu.
      let odakIcerideydi = this.contains(document.activeElement);
      // Odağı yalnız klavyeyle gezene taşı; dokunuşla odaklanan slayta dokunma
      try { odakIcerideydi = odakIcerideydi && document.activeElement.matches(':focus-visible'); } catch (_) {}

      if (this.azHareket.matches) {
        this.indeks = yeni;
        this.isaretle(yeni);
        if (odakIcerideydi) giren.focus({ preventScroll: true });
        this.basla();
        return;
      }

      this.gecisSuruyor = true;

      this.isit(yeni);

      clearTimeout(this.gizleZaman);
      this.slaytlar.forEach((s) => {
        if (s !== cikan && s !== giren && s.classList.contains('ethos-slider--cikan')) {
          s.classList.remove('ethos-slider--cikan');
          s.style.transform = '';
        }
      });

      const dpr = window.devicePixelRatio || 1;
      const piksel = (x) => Math.round(x * dpr) / dpr;

      giren.style.transform = `translate3d(${100 * d}%, 0, 0)`;
      giren.classList.add('ethos-slider--aktif');
      cikan.classList.add('ethos-slider--cikan');
      cikan.classList.remove('ethos-slider--aktif');

      // Erişilebilirlik durumu geçişin SONUNDA değil BAŞINDA dönmeli: kayma
      // boyunca çıkan slayt hâlâ ekranda ama artık gösterilmiyor sayılır.
      // inert olmadan çıkan slaydın bağlantısı sekme sırasında kalıyordu.
      giren.setAttribute('aria-hidden', 'false');
      giren.inert = false;
      cikan.setAttribute('aria-hidden', 'true');
      cikan.inert = true;

      const tur = (this.tur = (this.tur || 0) + 1);
      const sure = this.gecisSuresiMs();
      const egri = this.egri();
      let t0 = null;

      const bitir = () => {
        if (tur !== this.tur) return;
        this.tur++;
        cancelAnimationFrame(this.kareId);
        clearTimeout(this.emniyet);
        giren.style.transform = 'translate3d(0, 0, 0)';
        cikan.style.transform = `translate3d(${-100 * d}%, 0, 0)`;
        this.indeks = yeni;
        this.isaretle(yeni, cikan);
        // Çıkan slayt ekran dışında; gizlemeyi hareketin son karesinden ayır
        this.gizleZaman = setTimeout(() => {
          cikan.classList.remove('ethos-slider--cikan');
          cikan.style.transform = '';
        }, 200);
        // Görsel çözme bitiş karesine denk gelmesin
        setTimeout(() => { this.isit(yeni + 1); this.isit(yeni - 1); }, 400);
        this.gecisSuruyor = false;
        // Odağı yeni slayta taşı (slaytlarda tabindex="-1" var): hem ok tuşları
        // çalışmaya devam eder hem de odak içerideyken duraklatma korunur.
        if (odakIcerideydi && !this.contains(document.activeElement)) {
          giren.focus({ preventScroll: true });
        }
        this.kuyruguBosalt();
      };

      const kare = (simdi) => {
        if (tur !== this.tur) return;
        if (t0 === null) {
          t0 = simdi;
          clearTimeout(this.emniyet);
          this.emniyet = setTimeout(bitir, sure + 400);
        }
        const p = Math.min(1, (simdi - t0) / sure);
        const e = egri(p);
        // Genişlik her karede okunur (dönme/boyut değişimi); çıkan slayt girenden
        // türetilir ki iki slaytın birleşim çizgisi kare kare oynamasın.
        const genislik = this.kap.getBoundingClientRect().width;
        const x = piksel(d * genislik * (1 - e));
        giren.style.transform = `translate3d(${x}px, 0, 0)`;
        cikan.style.transform = `translate3d(${x - d * genislik}px, 0, 0)`;
        if (p < 1) this.kareId = requestAnimationFrame(kare);
        else bitir();
      };
      this.kareId = requestAnimationFrame(kare);

      // Emniyet: sekme arkadayken rAF hiç gelmeyebilir; geçiş yarıda asılı kalmasın.
      // İlk kare geldiğinde süre o andan yeniden kurulur.
      clearTimeout(this.emniyet);
      this.emniyet = setTimeout(bitir, sure + 400);

      this.basla();
    }

    /* --ethos-slider-egri: cubic-bezier(x1, y1, x2, y2) */
    egri() {
      const v = getComputedStyle(this).getPropertyValue('--ethos-slider-egri');
      const m = v.match(/cubic-bezier\(([^)]+)\)/);
      const [x1, y1, x2, y2] = m ? m[1].split(',').map(Number) : [0.83, 0, 0.17, 1];
      const b = (a1, a2, t) => ((1 - 3 * a2 + 3 * a1) * t + (3 * a2 - 6 * a1)) * t * t + 3 * a1 * t;
      const db = (a1, a2, t) => 3 * (1 - 3 * a2 + 3 * a1) * t * t + 2 * (3 * a2 - 6 * a1) * t + 3 * a1;
      return (x) => {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        let t = x;
        for (let i = 0; i < 8; i++) {
          const fark = b(x1, x2, t) - x;
          const egim = db(x1, x2, t);
          if (Math.abs(fark) < 1e-6) break;
          if (Math.abs(egim) < 1e-6) break;
          t -= fark / egim;
        }
        if (Math.abs(b(x1, x2, t) - x) > 1e-4) {
          let alt = 0, ust = 1;
          t = x;
          for (let i = 0; i < 30; i++) {
            const deger = b(x1, x2, t);
            if (Math.abs(deger - x) < 1e-6) break;
            if (deger < x) alt = t; else ust = t;
            t = (alt + ust) / 2;
          }
        }
        return b(y1, y2, t);
      };
    }

    gecisSuresiMs() {
      const v = getComputedStyle(this).getPropertyValue('--ethos-slider-sure').trim();
      if (v.endsWith('ms')) return parseFloat(v);
      if (v.endsWith('s')) return parseFloat(v) * 1000;
      return 900;
    }

    basla() {
      this.durdur();
      if (!this.otomatikIstendi || this.duraklatildi || this.azHareket.matches) return;
      if (document.hidden || this.odakIcerde || this.slaytlar.length < 2) return;
      // Diğer cihaza ayrılmış (display:none) slider dönmesin
      if (!this.getClientRects().length) return;
      // Kendiliğinden dönerken canlı bölgeyi sustur (Dawn de böyle yapıyor):
      // aksi halde ekran okuyucu 5 saniyede bir hero'yu baştan okuyup
      // kullanıcının sayfanın geri kalanını dinlemesini engelliyor.
      this.kap.setAttribute('aria-live', 'off');
      this.zamanlayici = setInterval(() => this.git(this.indeks + 1, 1), this.sure);
    }

    durdur() {
      if (this.zamanlayici) clearInterval(this.zamanlayici);
      this.zamanlayici = null;
      // Durduğunda slayt değişimi kullanıcı isteğiyle olur; artık duyurulmalı.
      this.kap.setAttribute('aria-live', 'polite');
    }

    otomatigiCevir() {
      this.duraklatildi = !this.duraklatildi;
      this.oynatDugmeleri.forEach((b) => {
        b.classList.toggle('slideshow__autoplay--paused', this.duraklatildi);
        const etiket = this.duraklatildi ? b.dataset.playLabel : b.dataset.pauseLabel;
        if (etiket) b.setAttribute('aria-label', etiket);
      });
      this.duraklatildi ? this.durdur() : this.basla();
    }
  }

  customElements.define('ethos-hero-slider', EthosHeroSlider);
})();
